import ContactForm from "./ContactForm"


const Contact = () => {

    return (
        <>
            <ContactForm/>
        </>
    )
}

export default Contact

